<template>
	<card>
		<template slot="header">
			<h5 v-if="$slots.title || title" class="card-title">
				<slot name="title">
					{{title}}
				</slot>
			</h5>
		</template>
		<div>
			<div class="container-fluid">
				<div class="row pl-5 pr-5 pt-5 pb-0 mb-4 time-control" v-if="!pickedDateRange">
					<div class="col-xs-6 mr-4 ml-4 pl-1 pr-1" :class="{'active': activeIndex=='current'}" id="a1" @click="setActive('current')">
						{{ currentTitle }}
					</div>
					<div class="col-xs-6 mr-4 ml-4 pl-1 pr-1" :class="{'active': activeIndex=='previous'}" id="a2" @click="setActive('previous')">
						{{ previousTitle }}
					</div>
				</div>
				<div class="row pl-5 pr-5 pt-5 pb-0 mb-4 time-control" v-else>
					<div class="col-xs-4 mr-4 ml-4 pl-1 pr-1" :class="{'active': activeIndex=='current'}" id="a1" @click="setActive('current')">
						{{ currentTitle }}
					</div>
					<div class="col-xs-4 mr-4 ml-4 pl-1 pr-1" :class="{'active': activeIndex=='previous'}" id="a2" @click="setActive('previous')">
						{{ previousTitle }}
					</div>
					<div class="col-xs-4 mr-4 ml-4 pl-1 pr-1" :class="{'active': activeIndex=='picked'}" id="a2" @click="setActive('picked')">
						Picked Date Range
					</div>
				</div>

				<div class="row  card-group" v-if="periodTime=='today'">
					<!-- <div class="text-center col-lg-6 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='picked'" >
						<div class="card-block">
							<h4 id="co-tablecell-title0" class="kpi-title">{{ pickedTitle }}</h4>
							<div id="co-tablecell-value0" class="kpi-content">£{{ pickedTotal }}</div>
						</div>
					</div> -->
					<div class="text-center col-lg-4 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='previous'">
						<div class="card-block">
							<h4 id="co-tablecell-title0" class="kpi-title">{{ setDisplayTitle(periodTime)[1] }}</h4>
							<div id="co-tablecell-value0" class="kpi-content">£{{ beforePrevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex !=='picked'">
						<div class="card-block">
							<h4 id="co-tablecell-title1" class="kpi-title">{{ setDisplayTitle(periodTime)[0] }}</h4>
							<div id="co-tablecell-value1" class="kpi-content">£{{ prevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title2" class="kpi-title">So Far Today</h4>
							<div id="co-tablecell-value2" class="kpi-content">£{{ sofarTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title3" class="kpi-title">Predicted Today</h4>
							<div id="co-tablecell-value3" class="kpi-content">£{{ predictTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title43" class="kpi-title">Change in Cost</h4>
							<div id="co-tablecell-value44" class="kpi-content" style="color: #E8506B;" v-if="changedPercent > 0">
								{{ changedPercent }} % ▲
							</div>
							<div id="co-tablecell-value55" class="kpi-content" style="color: #B4F9A1;" v-else>
								{{ Math.abs(changedPercent) }} % ▼
							</div>
						</div>
					</div>
				</div>
				<div class="row  card-group" v-if="periodTime=='month'">
					<div class="text-center col-lg-6 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='picked'" >
						<div class="card-block">
							<h4 id="co-tablecell-title0" class="kpi-title">{{ pickedTitle }}</h4>
							<div id="co-tablecell-value0" class="kpi-content">£{{ pickedTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='previous'">
						<div class="card-block">
							<h4 id="co-tablecell-title4" class="kpi-title">{{ setDisplayTitle(periodTime)[1] }}</h4>
							<div id="co-tablecell-value4" class="kpi-content">£{{ beforePrevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex !=='picked'">
						<div class="card-block">
							<h4 id="co-tablecell-title5" class="kpi-title">{{ setDisplayTitle(periodTime)[0] }}</h4>
							<div id="co-tablecell-value5" class="kpi-content">£{{ prevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title6" class="kpi-title">So Far This month</h4>
							<div id="co-tablecell-value6" class="kpi-content">£{{ sofarTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title7" class="kpi-title">Predicted This month</h4>
							<div id="co-tablecell-value7" class="kpi-content">£{{ predictTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title13" class="kpi-title">Change in Cost</h4>
							<div id="co-tablecell-value14" class="kpi-content" style="color: #E8506B;" v-if="changedPercent > 0">
								{{ changedPercent }} % ▲
							</div>
							<div id="co-tablecell-value15" class="kpi-content" style="color: #B4F9A1;" v-else>
								{{ Math.abs(changedPercent) }} % ▼
							</div>
						</div>
					</div>
				</div>
				<div class="row  card-group" v-if="periodTime=='year'">
					<div class="text-center col-lg-6 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='picked'" >
						<div class="card-block">
							<h4 id="co-tablecell-title0" class="kpi-title">{{ pickedTitle }}</h4>
							<div id="co-tablecell-value0" class="kpi-content">£{{ pickedTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-4 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='previous'">
						<div class="card-block">
							<h4 id="co-tablecell-title8" class="kpi-title">{{ setDisplayTitle(periodTime)[1] }}</h4>
							<div id="co-tablecell-value8" class="kpi-content">£{{ beforePrevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex !=='picked'">
						<div class="card-block">
							<h4 id="co-tablecell-title9" class="kpi-title">{{ setDisplayTitle(periodTime)[0] }}</h4>
							<div id="co-tablecell-value9" class="kpi-content">£{{ prevTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title10" class="kpi-title">So Far This year </h4>
							<div id="co-tablecell-value10" class="kpi-content">£{{ sofarTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title11" class="kpi-title">Predicted This Year</h4>
							<div id="co-tablecell-value11" class="kpi-content">£{{ predictTotal }}</div>
						</div>
					</div>
					<div class="text-center col-lg-3 col-md-6 col-sm-6 mb-4" v-if="activeIndex=='current'">
						<div class="card-block">
							<h4 id="co-tablecell-title23" class="kpi-title">Change in Cost</h4>
							<div id="co-tablecell-value24" class="kpi-content" style="color: #E8506B;" v-if="changedPercent > 0">
								{{ changedPercent }} % ▲
							</div>
							<div id="co-tablecell-value25" class="kpi-content" style="color: #B4F9A1;" v-else>
								{{ Math.abs(changedPercent) }} % ▼
							</div>
						</div>
					</div>
				</div>
				<div class="row pl-5 pr-5 pt-3 pb-0">
					<div class="col-xl-3 col-sm-6 col-xs-12 text-center">
						<button type="button" class="filter-action" @click="downloadCSV">Download CSV</button>
					</div>
					<div class="col-xl-3 col-xs-12" v-if="periodTime !== 'today'">
						<date-picker class="inline-block h-full text-center" @input="onDateRangeChange" v-model="pickedDateRange" :attributes ="attrs" is-range>
							<template v-slot="{ inputValue, togglePopover }">
								<div class="flex items-center"  style="display:flex;">
									<button
										class="timepickerbutton"
										@click="togglePopover()"
									>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16">
											<path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
										</svg>
									</button>
									<input
										:value="getValueTime(inputValue)"
										class="display-time"
										readonly
									/>
								</div>
							</template>
						</date-picker>
					</div>
					<div class="col-xl-3 col-lg-3 mb-3 text-center">
						<select id="appliance-select"  @change="selectField($event)" v-model="fieldName">
							<option v-for="usage in usages" :value="usage.value">{{ usage.label }}</option>
						</select>
					</div>
					<div class="col-xl-3 col-lg-3">
						<div id="usage-power-info" class="card-block">
							<div>
								<p class="ct-title"> {{ ctTitle }}</p>
								<p class="t-title">
									<!-- react-text: 22 -->Total<!-- /react-text -->
									<span id="elecvalue1" class="t-content">£{{ totalCost }}</span>
								</p>
								<p class="t-title">
									<!-- react-text: 22 -->Day<!-- /react-text -->
									<span id="elecvalue2" class="t-content">£{{ dayTotalCost }}</span>
								</p>
								<p class="t-title">
									<!-- react-text: 25 -->Night<!-- /react-text -->
									<span id="gasvalue3" class="t-content">£{{ nightTotalCost }}</span>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="row pt-3 pb-5 pr-5 pl-5">
					<vue-loaders-line-spin-fade-loader class="loading" color="white" scale="1.4"  v-if="isLoading"/>
					<v-chart class="chart" :option="option" v-else/>
				</div>
			</div>
		</div>
	</card>
</template>
<script>

import Card from "@/components/Cards/Card.vue";
import { mapActions, mapGetters } from "vuex";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart } from "echarts/charts";
import {
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
} from "echarts/components";
import VChart  from "vue-echarts";
import QuerySetting from '@/mixins/querySetting';
import SetDisplayTime from '@/mixins/setDisplayTime';
import OctoberData from '@/mixins/octoberData';
import {saveAs} from "file-saver";

use([
	CanvasRenderer,
	BarChart,
	TitleComponent,
	TooltipComponent,
	LegendComponent,
	GridComponent
]);

export default {
	name: "cost-page",
	mixins: [QuerySetting, SetDisplayTime, OctoberData],
	props: {
		title: {
			type: String,
			default: ""
		}
	},
	components: {
		Card,
		VChart
	},
	computed: {
		...mapGetters({
			periodTime					: 'settime/getPeriodTime',
			currentDayPower			: 'influx/getCurrentDayPower',
			currentNightPower		: 'influx/getCurrentNightPower',
			prevDayPower				: 'influx/getPrevDayPower',
			prevNightPower			: 'influx/getPrevNightPower',
			beforePrevDayPower	: 'influx/getBeforePrevDayPower',
			beforePrevNightPower: 'influx/getBeforePrevNightPower',
			predictDayPower			: 'influx/getPredictDayPower',
			predictNightPower		: 'influx/getPredictNightPower',
			user: 'auth/getUser',
			defaultSiteId: 'auth/getDefaultSiteId',
			defaultSiteName: 'auth/defaultSiteName'
		})
	},
	data() {
		return {
			isLoading: true,
			currentTitle: 'today',
			changedPercent: 0,
			pickedTotal: 0,
			pickedTime: [],
			pickedTitle: '',
			fieldName: 'overall',
			previousTitle: 'yesterday',
			activeIndex: 'current',
			sofarTotal: 0,
			ctTitle: 'so far today',
			pickedDateRange: null,
			prevTotal: 0,
			beforePrevTotal: 0,
			predictTotal: 0,
			dayTotalCost: 0,
			nightTotalCost: 0,
			attrs: [
				{
					key: 'today',
    				highlight: true,
					dates: new Date(),
				}
			],
			pickedDayPower: [],
					pickedNightPower: [],
			tariff: {
				day: 0,
				night: 0
			},
			totalCost: 0,
			previousDayDisplayData: [],
			currentDayDisplayData: [],
			previousNightDisplayData: [],
			currentNightDisplayData: [],
			usages: [{value: "overall", label: "Overall"}],
			CSVData: [],
			option: {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					backgroundColor: "#484E69",
					borderColor: "#484E69",
					textStyle: {
						color: 'white'
					}
				},
				legend: {
					itemWidth: 13,
					itemHeight: 13,
					itemGap: 30,
					textStyle: {
						color: 'white',
					},
					borderRadius: 0,
					bottom: 0,
					icon: 'rect'
				},
				color: ["#ADD8E6", "#800000"],
				grid: {
					left: '2%',
					right: '4%',
					bottom: '6%',
					containLabel: true
				},
				xAxis: [
					{
						type: 'time',
						axisLabel: {
							show: true,
							textStyle: {
								color: 'white',
								fontSize: '12px',
								fontWeight: 200,
								fontFamily: 'Nunito Sans Light',
							}
						},
						axisLine: {
							lineStyle: {
								type: 'solid',
								width: 6,
								borderColor: 'red'
							}
						},
						axisTick: {
							show: false
						}
					}
				],
				yAxis: [
					{
						type: 'value',
						axisLabel: {
							show: true,
							color: 'white',
							formatter: '£{value}'
						},
						splitLine: {
							lineStyle: {
								color: 'rgba(255, 255, 255, 0.3)',
								type: 'dashed',
								width: 1
							}
						},
						axisLine: {
							show: true,
							lineStyle: {
								width: 1
							}
						}
					}
				],
				series: [
					{
						name: 'Day',
						type: 'bar',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
					{
						name: 'Night',
						type: 'bar',
						emphasis: {
							focus: 'series'
						},
						data: []
					},
				]
			}
		}
	},
	watch: {
		async periodTime(newValue) {
			await this.getTariff(this.user.siteId);
			this.initDataPicker();
			this.initialCostData();
			this.changeTitle(newValue);
			await this.getCostData();
		},
		async defaultSiteId(newValue) {
			await this.getTariff(this.user.siteId);
			this.initDataPicker();
			this.initialCostData();
			this.changeTitle(newValue);
			await this.getCostData();
		}
	},
	created() {
		let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site;
		if (site === 'Brook Green' || site === 'Brook Green Updated') {
			this.usages = [
				{ value: "kitchen", label: "Kitchen" },
				{ value: "mbport", label: "MB Port" },
				{ value: "electrak", label: "Electrak" },
				{ value: "ac", label: "A/C Roof Comms Room" },
				{ value: "light", label: "Lights" },
				{ value: "overall", label: "Overall" },
			];
		} else {
			this.user.devices.forEach(device => {
				if (
					device.device_type !== 'Frequency' &&
					device.device_type !== 'Voltage' &&
					device.device_show === '1'
				) {
					this.usages.push(
						{value: device.device_name, label: device.device_name}
					)
				}
			});
		}
		
	},
	async mounted() {
		await this.getTariff(this.user.siteId);
		this.initDataPicker();
		this.initialCostData();
		this.changeTitle(this.periodTime);
		await this.getCostData();
	},
	methods: {
		...mapActions({
			getDisplayData: 'influx/getDisplayData',
			getPickedData: 'influx/getPickedDateRangeData',
			getRates: "admin/getRates",
		}),
		async getTariff(site) {
			const rates = await this.getRates(site);
			this.tariff = {
				day: rates[rates.length - 1].cost_1,
				night: rates[rates.length - 1].cost_2,
				gen: rates[rates.length - 1].cost_3
			}
		},
		initDataPicker() {
			this.pickedDateRange = null;
			this.activeIndex = 'current';
			this.pickedTime = [];
			this.pickedDayPower = [];
			this.pickedNightPower = [];
		},
		initialCostData() {
			this.sofarTotal = 0;
			this.prevTotal = 0;
			this.beforePrevTotal = 0;
			this.predictTotal = 0;
			this.totalCost = 0;
			this.dayTotalCost = 0;
			this.nightTotalCost = 0;
			this.option.series[0].data = [];
			this.option.series[1].data = [];
		},
		calculateCostFromPowerData(dayPower, nightPower) {
			let dayTotalCost = 0, nightTotalCost = 0;
			dayPower.forEach(item => {
				dayTotalCost += item[1] * this.tariff.day
			});
			nightPower.forEach(item => {
				nightTotalCost += item[1] * this.tariff.night;
			});

			return dayTotalCost + nightTotalCost;
		},
		makeCurrentWholeTimePower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth(), 2);
			let lastDay = date.setDate(date.getDate() + 1);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makePrevWholeTimePower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 2);
			let lastDay = new Date(date.getFullYear(), date.getMonth(), 1);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setDate(d.getDate() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makeCurrentWholeYearPower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear(), 0, 2);
			let lastDay = new Date(date.getFullYear(), 11, 2);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setMonth(d.getMonth() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		makePrevWholeYearPower(power) {
			let date = new Date();
			let firstDay = new Date(date.getFullYear() - 1, 0, 2);
			let lastDay = new Date(date.getFullYear() - 1, 11, 2);
			let powerData = [];
			for (var d = firstDay; d <= lastDay; d.setMonth(d.getMonth() + 1)) {
				let time = d.toISOString().slice(0, 10);
				let item = power.find(cur => cur[0] == time);

				if (item) {
					powerData.push([time, item[1]]);
				} else {
					powerData.push([time, 0]);
				}
			}
			return powerData;
		},
		async getCostData() {
			let sofarTotal = 0;
			let prevTotal = 0;
			let beforePrevTotal = 0;
			let predictTotal = 0;
			this.isLoading = true;

			if (this.option.series[0].hasOwnProperty('stack')) {
				delete this.option.series[0].stack;
				delete this.option.series[1].stack;
			}
		
			let payload = {
					field: this.fieldName,
					picked: this.pickedTime
				}
			if (this.fieldName == 'overall') {
				let pickedDayPower = [], pickedNightPower = [];
				let currentDayPower =[], currentNightPower = [];
				let prevDayPower =[], prevNightPower = [];

				if (!!this.pickedDateRange) {
					let powerData = await this.getPickedData(payload);
					pickedDayPower = powerData[0]; pickedNightPower = powerData[1];
					let cost = 0;
					pickedDayPower.map(item => cost += item[1] * this.tariff.day);
					pickedNightPower.map(item => cost += item[1] * this.tariff.night);
					this.pickedTotal = Math.round((cost + Number.EPSILON) * 100) / 100;
				} else {
					await this.getDisplayData(this.fieldName);
				}
				sofarTotal = this.calculateCostFromPowerData(this.currentDayPower, this.currentNightPower);
				this.sofarTotal = sofarTotal.toFixed(2);
				prevTotal = this.calculateCostFromPowerData(this.prevDayPower, this.prevNightPower);
				this.prevTotal = prevTotal.toFixed(2);
				beforePrevTotal = this.calculateCostFromPowerData(this.beforePrevDayPower, this.beforePrevNightPower);
				this.beforePrevTotal = beforePrevTotal.toFixed(2);
				predictTotal = this.calculateCostFromPowerData(this.predictDayPower, this.predictNightPower);
				this.predictTotal = (sofarTotal + predictTotal).toFixed(2);
				this.CSVData = [this.currentDayPower, this.currentNightPower];
				
				if (this.periodTime == 'today') {
					currentDayPower = this.currentDayPower;
					currentNightPower = this.currentNightPower;
					prevDayPower = this.prevDayPower;
					prevNightPower = this.prevNightPower;
				}

				if (this.periodTime == 'month') {
					currentDayPower = this.makeCurrentWholeTimePower(this.currentDayPower);
					currentNightPower = this.makeCurrentWholeTimePower(this.currentNightPower);
					prevDayPower = this.makePrevWholeTimePower(this.prevDayPower);
					prevNightPower = this.makePrevWholeTimePower(this.prevNightPower);
				}

				if (this.periodTime == 'year') {
					currentDayPower = this.makeCurrentWholeYearPower(this.currentDayPower);
					currentNightPower = this.makeCurrentWholeYearPower(this.currentNightPower);
					prevDayPower = this.makePrevWholeYearPower(this.prevDayPower);
					prevNightPower = this.makePrevWholeYearPower(this.prevNightPower);
				}


				this.getActiveDisplayData(
					currentDayPower,
					currentNightPower,
					prevDayPower,
					prevNightPower,
					pickedDayPower,
					pickedNightPower
				);

				if (this.activeIndex == 'current') {
					this.switchCurrentPreviousData(
						currentDayPower,
						currentNightPower
					);
				} 
				if (this.activeIndex == 'previous') {
					this.switchCurrentPreviousData(
						prevDayPower,
						prevNightPower
					);
				} 

				if (this.activeIndex == 'picked') {
					this.switchCurrentPreviousData(
						this.pickedDayPower,
						this.pickedNightPower
					);
				}
			} else {
				let powerData = [];
				let pickedDayPower = [], pickedNightPower = [];
				if (this.pickedTime.length > 0) {
					powerData = await this.getPickedData(payload);
					pickedDayPower = powerData[0]; pickedNightPower = powerData[1];
					let cost = 0;
					pickedDayPower.map(item => cost += item[1] * this.tariff.day);
					pickedNightPower.map(item => cost += item[1] * this.tariff.night);
					this.pickedTotal = Math.round((cost + Number.EPSILON) * 100) / 100;
				} else {
					powerData = await this.getDisplayData(this.fieldName);
				}
				let currentDayPower = powerData[0];
				let currentNightPower = powerData[1];
				let prevDayPower = powerData[2];
				let prevNightPower = powerData[3];
				let beforePrevDayPower = powerData[4];
				let beforePrevNightPower = powerData[5];
				let predictDayPower = powerData[6];
				let predictNightPower = powerData[7];

				if (this.periodTime == 'month') {
					currentDayPower = this.makeCurrentWholeTimePower(currentDayPower);
					currentNightPower = this.makeCurrentWholeTimePower(currentNightPower);
					prevDayPower = this.makePrevWholeTimePower(prevDayPower);
					prevNightPower = this.makePrevWholeTimePower(prevNightPower);
				}

				if (this.periodTime == 'year') {
					currentDayPower = this.makeCurrentWholeYearPower(currentDayPower);
					currentNightPower = this.makeCurrentWholeYearPower(currentNightPower);
					prevDayPower = this.makePrevWholeYearPower(prevDayPower);
					prevNightPower = this.makePrevWholeYearPower(prevNightPower);
				}

				sofarTotal = this.calculateCostFromPowerData(currentDayPower, currentNightPower);
				this.sofarTotal = sofarTotal.toFixed(2);
				prevTotal = this.calculateCostFromPowerData(prevDayPower, prevNightPower);
				this.prevTotal = prevTotal.toFixed(2);
				beforePrevTotal = this.calculateCostFromPowerData(beforePrevDayPower, beforePrevNightPower);
				this.beforePrevTotal = beforePrevTotal.toFixed(2);

				predictTotal = this.calculateCostFromPowerData(predictDayPower, predictNightPower);
				this.predictTotal = (sofarTotal + predictTotal).toFixed(2);
				this.CSVData = [currentDayPower, currentNightPower];
				this.getActiveDisplayData(
					currentDayPower,
					currentNightPower,
					prevDayPower,
					prevNightPower,
					pickedDayPower,
					pickedNightPower
				);
				if (this.activeIndex == 'current') {
					this.switchCurrentPreviousData(
						currentDayPower,
						currentNightPower
					);
				}

				if (this.activeIndex == 'previous'){
					this.switchCurrentPreviousData(
						prevDayPower,
						prevNightPower
					);
				}

				if (this.activeIndex == 'picked') {
					this.switchCurrentPreviousData(
						pickedDayPower,
						pickedNightPower
					);
				}
			}
			let changedPercent = 0;

			if (this.prevTotal === 0) {
				changedPercent = this.predictTotal;
			} else if (this.prevTotal > 0) {
				changedPercent = (this.predictTotal - this.prevTotal) / this.prevTotal * 100;
			}
			
			this.changedPercent = changedPercent.toFixed(2);
		},
		getActiveDisplayData(
			currentDay,
			currentNight,
			prevDay,
			prevNight,
			pickedDayPower,
			pickedNightPower
		) {
			this.currentDayDisplayData = currentDay;
			this.currentNightDisplayData = currentNight;
			this.previousDayDisplayData = prevDay;
			this.previousNightDisplayData = prevNight;
			this.pickedDayPower = pickedDayPower;
			this.pickedNightPower = pickedNightPower;
		},
		async onDateRangeChange() {
			if( !! this.pickedDateRange) {
				let start = this.pickedDateRange.start.toISOString();
				let end = this.pickedDateRange.end.toISOString();
				start = start.slice(0, 10) + 'T00:00:00Z';
				end = end.slice(0, 10) + 'T23:59:59Z';
				this.pickedTime = [start, end];

				await this.getTariff(this.user.siteId);
				this.initialCostData();
				this.changeTitle(this.periodTime);
				await this.getCostData();
			}
		},
		getValueTime(value) {
			if (value.start !== null ) {
				return 	value.start + '-' + value.end
			} else {
				return '';
			}
		},
		
		switchCurrentPreviousData(day, night) {
			let dayTotal = 0;
			let nightTotal = 0;
			let displayDay = [];
			let displayNight = [];

			for (let i = 0; i < day.length; i++) {
				displayDay.push([
					day[i][0],
					day[i][1] *  this.tariff.day
				])
				dayTotal += day[i][1] *  this.tariff.day;
			}

			for (let i = 0; i < night.length ; i++) {
				displayNight.push([
					night[i][0],
					night[i][1] *  this.tariff.night
				]);
				nightTotal +=  night[i][1] *  this.tariff.night;
			}

			let total = dayTotal + nightTotal;
			this.totalCost = total.toFixed(2);
			this.dayTotalCost = dayTotal.toFixed(2);
			this.nightTotalCost = nightTotal.toFixed(2);

			if (this.periodTime !== 'today' || (this.periodTime == 'today' && this.activeIndex=='picked')) {
				this.option.series[0].stack = 'cost';
				this.option.series[1].stack = 'cost';
			}

			// if (displayDay.length > 0 &&
			// 		displayNight.length > 0 &&
			// 		this.periodTime !== 'today' &&
			// 		displayDay[0][0] !== displayNight[0][0]) {
			// 	displayNight.splice(0, 0, [displayDay[0][0], 0]);
			// }

			// let site = this.defaultSiteName !== '' ? this.defaultSiteName : this.user.site
			// if (site === 'Richard Brown' && this.periodTime === 'month' && this.activeIndex !=='picked') {
			// 	let flag = false;

			// 	displayNight.map(item => {
			// 		if (item[0] === '2022-02-16') flag = true;
			// 	})
			// 	if (flag === false && this.activeIndex !== 'current') displayNight.splice(2, 0, ['2022-02-16', 0]);
			// }
		
			this.option.series[0].data = displayDay;			
			this.option.series[1].data = displayNight;
			this.isLoading = false;
		},
		changeTitle(value) {
			this.viewType = !this.viewType;
			let today = new Date();
			let label = this.usages.find(i => i.value === this.fieldName);
			if (!!this.pickedDateRange) {
				this.pickedTitle = this.pickedTime[0].slice(0,10) + ' - ' + this.pickedTime[1].slice(0,10);
			}
			switch (value) {
				case 'today':
					this.currentTitle = 'today';
					this.previousTitle = 'yesterday';

					if (this.activeIndex === 'current') {
						this.ctTitle = 'so far today ' + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + ' ' + label.label;
					}
					break;
				case 'month':
					this.currentTitle = 'this month';
					this.previousTitle = 'last month';

					if (this.activeIndex === 'current') {
						this.ctTitle = 'so far this month ' + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + ' ' + label.label;
					}
					break;
				case 'year':
					this.currentTitle = 'this year';
					this.previousTitle = 'last year';
					if (this.activeIndex === 'current') {
						this.ctTitle = 'so far this year ' + label.label;
					} else {
						this.ctTitle = this.setDisplayTitle(value)[0] + ' ' + label.label;
					}
					break;
			}
		},
		setActive(index) {
			this.activeIndex = index;
			this.changeTitle(this.periodTime);

			if (this.activeIndex == 'current') {
				this.switchCurrentPreviousData(
					this.currentDayDisplayData,
					this.currentNightDisplayData
				);
			} 
			if (this.activeIndex == 'previous') {
				this.switchCurrentPreviousData(
					this.previousDayDisplayData,
					this.previousNightDisplayData
				);
			}

			if (this.activeIndex == 'picked') {
				this.switchCurrentPreviousData(
					this.pickedDayPower,
					this.pickedNightPower
				);
			}


			
		},
		selectField(event) {
			this.fieldName = event.target.value;
			this.getCostData();
			this.changeTitle(this.periodTime);
		},
		getCSVData() {
			let csvJsonData = [];
			let dayPower = this.CSVData[0];
			let nightPower = this.CSVData[1];

			if (this.periodTime == 'today') {
				nightPower.map(item => {
					let csvObject = {};
					let timeKey = 'Local Time';
					let timeValue = new Date(item[0]);
					Object.assign(csvObject, {[timeKey]: timeValue});

					let nightPowerKey = this.fieldName + ' power(kWh)';
					let nightCostKey = this.fieldName + ' cost';
					let nightValue = item[1] * this.tariff.night;
					Object.assign(csvObject, {[nightPowerKey]: item[1]});
					Object.assign(csvObject, {[nightCostKey]: nightValue});
					csvJsonData.push(csvObject);
				});

				dayPower.map(item => {
					let csvObject = {};
					let timeKey = 'Local Time';
					let timeValue = new Date(item[0]);
					Object.assign(csvObject, {[timeKey]: timeValue});

					let dayPowerKey = this.fieldName + ' power(kWh)';
					let dayCostKey = this.fieldName + ' cost';
					let dayValue = item[1] * this.tariff.day;
					Object.assign(csvObject, {[dayPowerKey]: item[1]});
					Object.assign(csvObject, {[dayCostKey]: dayValue});
					csvJsonData.push(csvObject);
				});
			} else {
				dayPower.map((item, index) => {
					let csvObject = {};
					let timeKey = 'Local Time';
					let timeValue = new Date(item[0]).toISOString().slice(0, 10);
					Object.assign(csvObject, {[timeKey]: timeValue});

					let dayPowerKey = this.fieldName + ' day power(kWh)';
					let dayCostKey = this.fieldName + ' day cost';
					let dayValue = item[1] * this.tariff.day;
					Object.assign(csvObject, {[dayPowerKey]: item[1]});
					Object.assign(csvObject, {[dayCostKey]: dayValue});

					let nightPowerKey = this.fieldName + ' night power(kWh)';
					let nightKey = this.fieldName + ' night cost';
					let nightValue = nightPower[index][1] * this.tariff.night;
					Object.assign(csvObject, {[nightPowerKey]: nightPower[index][1]});
					Object.assign(csvObject, {[nightKey]: nightValue});

					let totalPower = 'total power(kWh)';
					let totalKey = 'total cost';
					let totalValue = dayValue + nightValue;
					Object.assign(csvObject, {[totalPower]: item[1] + nightPower[index][1] });
					Object.assign(csvObject, {[totalKey]: totalValue});

					csvJsonData.push(csvObject);
				});
			}
			return csvJsonData;
		},
		getCSVfile(data) {
			const replacer = (key, value) => value === null ? '' : value;
			const header = Object.keys(data[0]);
			let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
			csv.unshift(header.join(','));
			let csvArray = csv.join('\r\n');

			var blob = new Blob([csvArray], {type: 'text/csv' });
			let todayString = new Date().toISOString().slice(0,10);
			let name = 'knowatts.co.uk_download_' + todayString;
			saveAs(blob, `${name}.csv`);
		},
		downloadCSV() {
			let data = this.getCSVData();
			this.getCSVfile(data);
		},
	},
};
</script>
<style lang="scss" scoped>
.chart {
	height: 500px;
}

#a2, #a1 {
	color: rgb(253, 253, 253);
	opacity: 0.5;
	text-transform: uppercase;
	cursor: pointer;
}

#a1:before, #a2:before {
	transition: border-bottom 0.3s ease;
}

.active {
	opacity: 1 !important;
	border-bottom: 2px solid rgb(253, 253, 253);
}
#usage-power-info {
	max-width: 180px;
	margin: 0 auto;
}

.loading {
	top: 100% !important;
	left: 47% !important;
	padding: 10px;
}

.t-head {
	text-align: center;
	margin-bottom: 5px;
	padding-bottom: 5px;
	font-size: 32px;
	color: #fdfdfd;
	font-family: 'Nunito Sans Semi-bold';
}
.t-title {
	font-size: 16px;
	font-family: 'Nunito Sans Light';
	text-align: left;
	margin-right: 0;
	margin-top: 0;
	margin-bottom: 0;
	color: hsla(0,0%,99%,.7);
	width: 100%;
	padding: 0 15px;

	.t-content {
		font-size: 16px;
		color: #fdfdfd;
		font-family: 'Nunito Sans Regular' !important;
		float: right;
		margin-left: -10px;
		padding-left: 0;
	}
}

.timepickerbutton {
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.display-time {
	width: 180px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	color: white;
}

#appliance-select {
	width: 160px;
	height: 30px;
	background-color: #1e365d;
	color: #FFFFFF;
	opacity: 0.9;
	border-color: #fdfdfd;
	border-radius: 4px;
}

.kpi-title {
	font-size: 16px !important;
	text-transform: uppercase;
	color: #fdfdfd;
	opacity: .8;
	font-family: 'Nunito Sans Light';
	font-weight: 100;
}

.kpi-content, .t-head {
	font-size: 32px;
	color: #fdfdfd;
	font-family: 'Nunito Sans Semi-bold';
}

.card-group {
	flex-flow: row wrap;
	display: flex;
}

.ct-title {
	text-transform: uppercase;
	text-align: center;
	color: rgba(252, 252, 252, 0.7);
	font-size: 16px;
}

.filter-action {
	width: 160px;
	height: 30px;
	border: 1px	solid #fdfdfd;
	background-color: #1e365d;
	color: white;
	border-radius: 4px;
	z-index: 8;
	&:hover {
		background-color: #1f5881;
	}
}
</style>
